import { render, staticRenderFns } from "./EvaluationForm.vue?vue&type=template&id=90580570&scoped=true"
import script from "./EvaluationForm.vue?vue&type=script&lang=js"
export * from "./EvaluationForm.vue?vue&type=script&lang=js"
import style0 from "./EvaluationForm.vue?vue&type=style&index=0&id=90580570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90580570",
  null
  
)

export default component.exports